import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ProcessInProgress } from '@oh-vcp/components-ui';
import { useAuth } from './AuthContext';
import { useEconsultCaseDetailsContext } from '../econsultCaseDetailsContext/EconsultCaseDetailsContext';

const LoginCallback = () => {
  const { handleAndValidateToken } = useAuth();
  const { setFhirPatientGuid, setFhirContext, fhirPatientGuid, fhirContext } =
    useEconsultCaseDetailsContext();
  const searchParams = new URLSearchParams(window.location.search);
  handleAndValidateToken(true);
  const { t } = useTranslation();

  useEffect(() => {
    if (setFhirPatientGuid) {
      const fhirPatientGuid = searchParams.get('patient');
      setFhirPatientGuid(fhirPatientGuid || undefined);
    }
  }, [setFhirPatientGuid]);

  useEffect(() => {
    if (setFhirContext) {
      const fhirContext = searchParams.get('fhirContext');
      setFhirContext(fhirContext || undefined);
    }
  }, [setFhirContext]);

  useEffect(() => {
    if (fhirPatientGuid || fhirContext) {
      sessionStorage.setItem('integration', 'halo');
    } else {
      sessionStorage.removeItem('integration');
    }
  });

  const access_token = searchParams.get('access_token');
  if (access_token) {
    sessionStorage.setItem('token', access_token);
  }

  const refresh_token = searchParams.get('refresh_token');
  if (refresh_token) {
    sessionStorage.setItem('refreshToken', refresh_token);
  }

  return <ProcessInProgress title={t('loginInProgress')} />;
};

export default LoginCallback;
